import { Typography } from '@packages/ui/shared';
import { useTranslation } from 'react-i18next';

import { DECISION_MODAL_WIDTH } from '../ssm5.constants';
import { ssm5TextStyles } from '../ssm5.styles';
import { Ssm5Modal } from './ssm5-modal';

/** Props for {@link Ssm5LeaveWarningModal}. */
export type Ssm5LeaveWarningModalProps = {
    /** Called when the technician leaves and loses the attempt. */
    onLeave: () => void;
    /** Called when the technician stays and lets the attempt finish. */
    onStay: () => void;
    /** Whether the warning is visible. */
    show: boolean;
};

/**
 * Modal warning the technician that leaving now drops the running SSM5 connection attempt.
 *
 * @param props - {@link Ssm5LeaveWarningModalProps}
 * @returns the modal
 */
export function Ssm5LeaveWarningModal({ onLeave, onStay, show }: Ssm5LeaveWarningModalProps) {
    const { t } = useTranslation();

    const actions = {
        primary: { onPress: onStay, title: t('ssm5:leaveWarning.stay') },
        secondary: { onPress: onLeave, title: t('ssm5:leaveWarning.leave') },
    };

    return (
        <Ssm5Modal
            actions={actions}
            look="card"
            onHide={onStay}
            show={show}
            title={t('ssm5:leaveWarning.title')}
            width={DECISION_MODAL_WIDTH}
        >
            <Typography style={ssm5TextStyles.body} variant="default">
                {t('ssm5:leaveWarning.description')}
            </Typography>
        </Ssm5Modal>
    );
}
